module.exports = __webpack_public_path__ + "img/facebook.690009a4.svg";